import { z } from "zod";
import { uuidLoose } from "./uuid.js";
/**
 * Body for PATCH /v1/storefront/me/profile. The `min(1).max(200)` bounds are
 * a product/UX limit (form-field sanity), NOT a DB constraint — the
 * `users.name` column is unbounded `TEXT`.
 */
export const ProfileUpdateRequestSchema = z.object({
    name: z.string().trim().min(1).max(200),
});
/**
 * Body for PATCH /v1/storefront/me/default-location. `locationId` MUST be in
 * the customer's allowed list (server checks `customer_locations` row exists).
 *
 * NOTE: uses `uuidLoose` (NOT `z.uuid()`) because seeded version-0 UUIDs are
 * accepted everywhere else.
 */
export const DefaultLocationUpdateRequestSchema = z.object({
    locationId: uuidLoose,
});
